import { UserLevelType } from 'src/type/user';

import { useState, useEffect } from 'react';
import { useBoolean } from 'src/hooks/use-boolean';
import axios, { endpoints } from 'src/utils/axios';
import { toastError } from 'src/utils/format-error';
import LoadingContainer from 'src/components/ui-kit/loading-container';
import SettingUserLevelProfit from './setting-user-level-profit';

export default function SettingProfit() {
  const initialize = useBoolean(true);
  const [levelProfit, setLevelProfit] = useState(Array<UserLevelType>());

  const reload = useBoolean();

  useEffect(() => {
    load();
  }, [reload.value]);

  const load = async () => {
    try {
      const userLevelResponse = await axios.get<UserLevelType[]>(endpoints.userLevel.get);
      setLevelProfit(userLevelResponse.data);
    } catch (error) {
      toastError(error);
    } finally {
      initialize.onFalse();
    }
  };

  return (
    <LoadingContainer loading={initialize.value} sx={{ minHeight: '30vh' }} fitContent>
      <SettingUserLevelProfit levelProfit={levelProfit} forceReload={reload.onToggle} />
    </LoadingContainer>
  );
}
